import { makeStyles } from '@material-ui/core';

const useSummaryStyles = makeStyles((theme) => ({
  board: {
    padding: '30px 30px 30px 30px',
    border: `1px solid ${theme.palette.grey[300]}`,
    marginBottom: 58,
    borderRadius: 5,
    position: 'relative',
    [theme.breakpoints.down('xs')]: {
      padding: '10px 0 30px 0',
      border: 'none',
      borderBottom: `1px solid ${theme.palette.grey[300]}`,
    },
  },
  title: {
    position: 'absolute',
    left: 22,
    top: 0,
    transform: `translateY(-50%)`,
    padding: 8,
    background: theme.palette.common.white,
    [theme.breakpoints.down('xs')]: {
      left: '0',
      padding: 0,
    },
  },
  subTitle: {
    fontWeight: '500!important',
    fontSize: 18,
    marginBottom: 10,
    marginTop: 32,
  },
  fieldContainer: {
    marginBottom: 15,
    display: 'flex',
  },
  label: {
    color: theme.palette.grey[600],
    width: '100%',
    minWidth: 140,
    maxWidth: 140,
    marginRight: 37,
  },
  editButton: {
    position: 'absolute',
    right: 37,
    top: 0,
    transform: `translateY(-50%)`,
    background: theme.palette.common.white,
    '&:hover': {
      background: theme.palette.common.white,
    },
    [theme.breakpoints.down('xs')]: {
      right: 0,
    },
  },
  image: {
    maxWidth: 190,
  },
  providedData: {
    wordBreak: 'break-all',
  },
}));

export default useSummaryStyles;
